import { dataProps } from './properties'

export const setEStoreTopMenuList = (state, payload) => {
    state.list = payload
}    

export const setEStoreTopMenuData = (state, payload) => {
    state.props = payload
} 

export const resetEStoreTopMenuData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const sortEStoreTopMenuList = (state, payload) => {

    let key = (payload.sl_no)

    if(payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no+1
        state.list[key+1].sl_no = payload.sl_no         
    } else if(payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no-1
        state.list[key-1].sl_no = payload.sl_no         
    }

    state.list = state.list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });

}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreTopMenu/mutations.js